<template>
  <f7-list accordion-list v-if="documents" id="payments-item-received" class="itemList">
    <ul v-for="document in documents" :key="document.IdDocument">
      <li class="swipeout" @click="seeDetails(document)">
        <div class="item-content boxRequest">
          <div class="item-media">
            <div id="greenRectangle" :style="{background: rectangleColor}"></div>
            <i class="icon list-icon" :class="getIcon(document.Status)"></i>
          </div>
          <div class="item-inner">
            <table width="100%" style="table-layout: fixed;">
              <tr>
                <td width="20%" :class="getLabelColorClass(document.Status)">
                  <span class="showLargeScreenOnly">
                    {{ getStatusLabel(document.Status, document.Role) }}
                  </span>
                </td>
                <td>
                  <span class="showLargeScreenOnly">
                    {{ getDocumentType(document) }}
                  </span>
                </td>
                <td>
                  <span class="showLargeScreenOnly">
                    {{ document.GroupReference }}
                  </span>
                </td>
                <td>
                  <span class="showLargeScreenOnly">
                    {{ getDate(document) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="detailsDocumentStatus showSmallScreenOnly">
                  {{ getStatusLabel(document.Status, document.Role) }}
                </td>
              </tr>
              <tr>
                <td class="showSmallScreenOnly" colspan="4">
                  {{ getDate(document) }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </li>
    </ul>
  </f7-list>
</template>

<script>
import documentSerialize from '@/helpers/documentSerialize.json'
import {loadPage} from '@/helpers/routing'
import {statusLabel, statusIcon} from '@/helpers/labels'

export default {
  name: 'DocumentToValidateList',
  props: ['documents', 'filterBy'],
  data () {
    return {
      rectangleColor: this.$engine.services.getServiceColor(this.$engine.user.currentService.id),
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      sharedFoldersConfig: this.$engine.services.businessDocuments.sharedFoldersConfig
    }
  },
  created () {
  },
  methods: {
    getDate (document) {
      return this.$i18n.t('businessDocuments.last_update_on') + ' ' + this.$options.filters.formatDate(document.LastUpdateDate)
    },
    getDocumentType (document) {
      return this.$i18n.t(documentSerialize[document.Type].label)
    },
    getFolderInfo () {
      this.$emit('get-folder-info')
    },
    getIcon (status) {
      return statusIcon('Doc_' + status)
    },
    getLabelColorClass (status) {
      if (status.toString() === '13' || status.toString() === '16') {
        return 'MoneyRoadcolorOK'
      } else if (status.toString() === '12' || status.toString() === '14') {
        return 'MoneyRoadcolorKO'
      } else {
        return ''
      }
    },
    getStatusLabel (status, role) {
      return statusLabel(this.$i18n, 'Doc_' + status, role, -1, -1, this.$engine.user.get())
    },
    seeDetails (document) {
      this.$engine.services.businessDocuments.currentDocument = document
      loadPage(this, {url: '/suppliers/documentsToValidateDetails'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// DocumentToValidateList.vue?23e768ee